import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className='footer mt-16 bg-secondary text-center'>
           <h1 className='text-center my-4 text-2xl text-white'>All copyrights reserved </h1>
        </div>
    );
};

export default Footer;

